/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

import loading from "../../assets/error.jpg";
import ColoredH1 from "../ColoredHeader";

import { colors } from "../../theme";
import _get from "lodash/get";

const Error = ({ error }) => (
    <>
        <img
            data-testid="error-image"
            css={css`
                align-self: center;
                margin-top: 40px;
                margin-bottom: 40px;
            `}
            src={loading}
            alt="Illustration of a dog chasing its tail"
        />
        <ColoredH1
            additionalStyles={css`
                text-align: center;
            `}
            color={colors.neutral8}
        >
            Sorry, something went wrong
        </ColoredH1>
        <p
            css={css`
                align-self: center;
                &&& {
                    font-size: 18px;
                }
            `}
        >
            Try refreshing, that usually helps
        </p>
        <p
            data-testid="error-message"
            css={css`
                align-self: center;
                text-align: center;
                &&& {
                    font-size: 18px;
                }
            `}
        >
            If refreshing doesn’t solve the issue, please contact our support
            team so we can help you out. Reach us at{" "}
            <a href="mailto:support@mytutor.co.uk">support@mytutor.co.uk</a> or{" "}
            <a href="tel:+44-0203-773-6020">+44 (0) 203 773 6020</a>
        </p>
        {_get(error, "data.code") && (
            <p
                data-testid="error-code"
                css={css`
                    align-self: center;
                    text-align: center;
                    &&& {
                        font-size: 18px;
                    }
                `}
            >
                Please note down and quote the error code: <br />
                {_get(error, "data.code")}
            </p>
        )}
    </>
);

export default Error;
